<template lang="html">
  <div class="form-doc">
    <h6 class="title">Regístrate</h6>
    <div class="row first">
      <div class="col-12 col-md-6 my-3 my-md-0">
        <Input 
          placeholder="Nombre" 
          :onChange="(value) => (name = value)"
          :value="name"
        />
      </div>
      <div class="col-12 col-md-6 my-3 my-md-0">
        <Input 
          placeholder="Apellido" 
          :onChange="(value) => (lastname = value)"
          :value="lastname"
        />
      </div>
    </div>
    <div class="row second">
      <div class="col-12">
        <Input 
          placeholder="Email" 
          :onChange="(value) => (email = value)"
          :value="email"
        />
        
      </div>
    </div>
    <div class="row third">
      <div class="col-12">
        <Checkbox 
        id="acept07" 
        text="Acepto Terminos y Condiciones" 
        :onChange="(value) => (aceptar = value)"
        :value="aceptar"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <Button style="width: 100%" :clickBtn="this.onSend"
          >Registrarme</Button
        >
      </div>
    </div>
    <ModalRegister
      :show="modalStatus"
      @updateShow="modalStatus = $event"
      :eventSuccess="this.successPopup"
      title="Registro Exitoso"
      description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vehicula euismod diam."
      coverImg="https://i.ibb.co/MhzbWmw/Footer-Doc.png"
      action="Aceptar"
    />
  </div>
</template>
<script>
import Input from "../General/Input.vue";
import Checkbox from "../General/Checkbox.vue";
import Button from "../General/Button.vue";
import ModalRegister from "../Document/ModalRegister.vue";

export default {
  components: {
    Input,
    Checkbox,
    Button,
    ModalRegister,
  },
  data() {
    return {
      modalStatus: false,
      name: "",
      lastname: "",
      email: "",
      message: "",
      aceptar: false,
    };
  },
  methods: {
    openPopup() {
      this.modalStatus = true;
    },
    successPopup() {
      this.modalStatus = false;
    },
    onSend() {
      const _this = this;

      if (this.aceptar) {
        this.addRow({
          inputs: {
            name: this.name,
            lastname: this.lastname,
            email: this.email,
            title: this.title,
          },
          type: "POST",
          url: "sendContact",
        })
          .then((res) => {
            console.log(res);
            if (res.data.data === 'success') {
              this.openPopup();
              _this.name = "";
              _this.lastname = "";
              _this.email = "";
              _this.aceptar = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>
<style lang="css" scoped>
.form-doc .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 28px;
  color: #013652;
  margin-bottom: 26px;
}
.row.first {
  margin-bottom: 20px;
}
.row.second {
  margin-bottom: 12px;
}
.row.third {
  margin-bottom: 28px;
}
</style>
